import React,{useState, useEffect, Fragment} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import { association,api } from "../../apis/urls";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";



const AthletView = () => {



    useEffect(() => {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        $('.sidebar-toggler').removeClass('toggle-opacity').addClass('');


        setTimeout(() => {
            Listing();
            });
    }, []);
    
    let navigate = useNavigate();

    const { id } = useParams();

    const role = localStorage.getItem('userrole');

    const [result, setResult] = useState([]);
    const [sportresult, setSportResult] = useState([]);
    const [count, setCount] = useState('');
    const [schoolView, setSchoolView] = useState([]);



    const Listing = () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
    
        const instance = axios.create({
            baseURL: association+id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {
            setSchoolView(res.data.schools)
            setResult(res.data.data);
            setSportResult(res.data.data.sport);
            setCount(res.data.official_count)
            // console.log("datas", res.data);    
            // setLoader(false)
        });
    }


    const StatusChange = () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const data = {
            ids: id
        }
    
        const instance = axios.create({
            baseURL: association+"status",
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.patch('', data).then(res => {

            Listing();
            // setLoader(false)
        });
    }

    const DeleteAssociation = (id) => {
        let r = window.confirm("Are you sure you want to delete this Association?");

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: association+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                Listing();
                const navigates = navigate("/associations")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            });
        }else{
            navigate("/associations")
        }
    }

    return(
        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Association View </h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            
                            { role === 'ASSOCIATION_USER' ?null :
                            (   <Fragment>
                                    <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/associations"> Association List</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Association View</li>
                                </Fragment>
                                
                            )
                            
                            }
                            
                            
                        </ol>
                    </nav>

                    <div className="tab-content">

                        <div id="generalinfo" class="containers tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Association Name</label>
                                    <div>{decode(result.name)}</div>
                                </div>
                                <div class="col-md-3">
                                    <label>Sports Name</label>
                                    {sportresult === null?
                                    <div>Sports not found<br/>   
                                    </div>:
                                    <div>{sportresult.name}<br/>   
                                    </div>}
                                </div>
                                <div class="col-md-3">
                                    <label>Association Email</label>
                                    <div>{result.email}</div>
                                </div>
                                <div class="col-md-3">
                                    <label> Association Phone</label>
                                    <div>{result.phone}</div>
                                </div>
                            </div>

                            <div class="row tab-section">

                            <div class="col-md-4">
                                    <label>Address</label>
                                    <div>
                                        {result.address}
                                        {result?.street? ", " + result?.street :null}
                                        {result?.city? ", " + result?.city :null}
                                        <br />
                                        {result?.state? result?.state :null}
                                        {result?.zip? ", " + result?.zip :null}
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>No of Officials</label>
                                    <div>{count}<br/>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>GIAA Member Schools</label>
                                    {schoolView.map((item)=>
                                        <div>{item.name}</div>
                                    )}
                                </div>
                            </div>



                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Assignor Name</label>
                                    <div>{result.pri_firstname?result.pri_firstname:"-"} &nbsp; {result.pri_lastname?result.pri_lastname:null}</div>
                                </div>
                                <div class="col-md-3">
                                    <label>Assignor Email</label>
                                    <div>{result.pri_email?result.pri_email:"-"}<br/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label>Assignor Phone</label>
                                    <div>{result.pri_phone?result.pri_phone:"-"}<br/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label>Assignor Address</label>
                                    
                                    <div>
                                        {result.pri_address}
                                        {result?.pri_street? ", " + result?.pri_street :null}
                                        {result?.pri_city? ", " + result?.pri_city :null}
                                        <br />
                                        {result?.pri_state? result?.pri_state :null}
                                        {result?.pri_zip? ", " + result?.pri_zip :null}
                                    </div>
                                </div>
                            </div>



                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Secretary Name/Treasurer Name</label>
                                    <div>{result.sec_name?result.sec_name:"-"}</div>
                                </div>
                                <div class="col-md-3">
                                    <label>Secretary Email/Treasurer Email</label>
                                    <div>{result.sec_email?result.sec_email:"-"}<br/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label>Secretary Phone/Treasurer Phone</label>
                                    <div>{result.sec_phone?result.sec_phone:"-"}<br/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label>Secretary Address/Treasurer Address</label>
                                    <div>
                                        {result.sec_address}
                                        {result?.sec_street? ", " + result?.sec_street :null}
                                        {result?.sec_city? ", " + result?.sec_city :null}
                                        <br />
                                        {result?.sec_state? result?.sec_state :null}
                                        {result?.sec_zip? ", " + result?.sec_zip :null}
                                    </div>
                                </div>
                            </div>




                            <div className="list-action-wrpr showicons roundicons-text">
									<div className="list-action-wrpr">
										<Link   to={"/edit_associations/"+id}data-toggle="tooltip" title="Edit">
											<i class="edit icon-pencil3"></i><span>Update</span>
										</Link>
                                        { role === 'ASSOCIATION_USER' ?null :
                                            (
                                                <button data-toggle="tooltip" onClick={() => { DeleteAssociation(id) } } 
                                            style={{backgroundColor: '#fff'}}  title="Delete"  ><a><i  class="delete icon-close1"
                                            ></i><span>Delete</span></a></button>
                                            )
                                        }
                                        
                                        {/* {result.status ==='YES'?                                    
                                            <button onClick={StatusChange} style={{background:"transparent"}} data-toggle="tooltip" title="Unpublish"><a><i class="delete icon-publish" style={{background:'#00eaad'}}></i><span>Approved</span></a></button>:
                                            <button onClick={StatusChange} style={{background:"transparent"}} data-toggle="tooltip" title="Publish"><a><i class="delete icon-tick" style={{background:'#0069FF'}}></i><span>Rejected</span></a></button>
                                        } */}

									</div>
								</div>
                        </div>

                    </div>



                </div>
            </aside>
        </div>
    )
}

export default AthletView;